import { IState } from '../../store';

export const selectAsideActiveAnchor = (state: IState): string => {
  return state.aside.activeAnchor;
};
